<script>
import _ from 'lodash'
import FollowupRecordService from '@/request/followup/followupRecord'
import FollowupRecord from './followup-record'
export default {
  name: 'FollowupRecordList',
  components: {
    FollowupRecord
  },
  props: {
    fuid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      records: []
    }
  },
  computed: {},
  created: function () {
    if (this.fuid) {
      this.listRollowupRecord()
    }
  },
  watch: {
    fuid () {
      this.listRollowupRecord()
    }
  },
  methods: {
    listRollowupRecord () {
      let self = this
      if (!self.fuid) {
        self.records = []
        return
      }
      FollowupRecordService.listRecord({
        fuid: self.fuid
      }).then(record => {
        self.records = _.clone(record.result || [])
      })
    }
  },
  filters: {}
}
</script>

<template>
  <transition-group
      tag="ul"
      class="record-list"
      name="record-list">
    <template v-if="records.length > 0">
      <li class="record-item" v-for="item in records" :key="item.id">
        <followup-record :data="item"></followup-record>
      </li>
    </template>
    <li v-if="records.length === 0" :key="0">
      <span>还没有随访记录</span>
    </li>
  </transition-group>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline;
}
.record-item {
  -webkit-transition: all .5s cubic-bezier(.55,0,.1,1);
  transition: all .5s cubic-bezier(.55,0,.1,1);
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-top: 5px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}
</style>
